import { useCallback } from "react";
import { useThorEvent } from "@aviv-dxp/react-thor";
import { useLocation } from "@aviv-unified-frontend/runtime/router";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
import { useAuthentication } from "@aviv-unified-frontend/runtime/authentication";

import { STAGE_LIKE_ENVIRONMENT } from "../../../constants/environment";
import { BRAND_CONFIGURATION } from "../../../../configs/brands";

const { id } = BRAND_CONFIGURATION;

type Variant = "a" | "b";

const AB_VARIANTS = {
  a: "Overlay_versionA",
  b: "Overlay_versionB",
};

const getAbVariant = (variant?: Variant) => {
  return variant ? AB_VARIANTS[variant] : "";
};

export const useCustomBannerTracking = (variant?: Variant) => {
  const { state } = useAuthentication();
  const { pathname } = useLocation();
  const { language } = useLocale();
  const ab_variant = getAbVariant(variant);

  const event = useThorEvent({
    eventData: {
      av_zone: "bottom",
      // @ts-expect-error The event is not yet implemented Thor side: the error exception will be removed once Thor is updated or replaced by the new Tracking library.
      av_platform: "web",
      av_initiative: "kr01_web-to-app",
      av_url_path: pathname,
      av_environment: STAGE_LIKE_ENVIRONMENT,
      av_language: language,
      av_site: id.toUpperCase(),
      av_u_status: state === "authenticated" ? "logged" : "unlogged",
      ...(ab_variant && { ab_variant }),
    },
  });

  const onDisplayEvent = useCallback(() => {
    event({
      eventData: {
        // @ts-expect-error The event is not yet implemented Thor side: the error exception will be removed once Thor is updated or replaced by the new Tracking library.
        event: "web2app_banner_view",
      },
      unique: true,
    });
  }, [event]);

  const onClickEvent = useCallback(
    (link_text: string) => {
      event({
        eventData: {
          // @ts-expect-error The event is not yet implemented Thor side: the error exception will be removed once Thor is updated or replaced by the new Tracking library.
          event: "web2app_banner_download",
          link_text,
        },
      });
    },
    [event],
  );

  const onDismissEvent = useCallback(() => {
    event({
      eventData: {
        // @ts-expect-error The event is not yet implemented Thor side: the error exception will be removed once Thor is updated or replaced by the new Tracking library.
        event: "web2app_banner_dismiss",
      },
    });
  }, [event]);

  return {
    onDisplayEvent,
    onClickEvent,
    onDismissEvent,
  };
};
